import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { AuthorizationService } from "../authorization/authorization.service";
import { WindowRef } from '../../utils/window';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { DTFHomepageService } from "../dtfhomepage/dtfhomepage.service";
import { Banner } from "../../shared/models/banner";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatExpansionModule, MatExpansionPanel } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { PasswordResetComponent } from "../passwordreset/passwordreset.component";
import { PasswordResetConfirmComponent } from "../passwordresetconfirm/passwordresetconfirm.component";
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";


@Component({
    selector: "div.dtf-adminpage",
    imports: [SharedTranslateModule,SessionTimeoutComponent, PasswordResetConfirmComponent, MatTableModule, FormsModule, MatRadioModule, ReactiveFormsModule, MatExpansionModule, MatToolbarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatMenuModule, MatCheckboxModule],
    templateUrl: './admin.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class AdminComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  currentCountry: string;
  language = '';
  targetRedirect = '';
  usUrl: string;
  caUrl: string;
  toggleOpen: any;
  public alerts: Banner;
  dbData: any;
  passwordResetFlag = false;

  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public dtfhomepageService: DTFHomepageService,
    public translateUtil: TranslateUtil
  ) {
    this.router = router;
}
  ngOnInit() {
    const language = (window as any).mbfs.language;
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
    //this.getAlerts();
    const passwordreset = (this._window.nativeWindow as any).mbfs.passwordreset;
    if(passwordreset !=""){
      this.checkPassword();
    }
    this.langInit();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  checkPassword(){
    this.passwordResetFlag=true;
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //       for (var i = 0; i < res.length; i++) {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     });
  // }
}
